import { Button } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

export const CardWrapper = styled.div`
  align-items: center;
  background-color: var(--color-bg-body);
  border-radius: var(--size-border-radius-md);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  padding: var(--size-padding-8);
  width: 420px;
`;

export const CircleAnimation = styled.div`
  animation: circle-animation 2s infinite;
  border: 2px solid #fce033;
  border-radius: var(--size-border-radius-circle);
  height: 24px;
  position: absolute;
  width: 24px;

  @keyframes circle-animation {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    50% {
      transform: scale(1.5);
      opacity: 0.8;
    }
    100% {
      transform: scale(2);
      opacity: 0;
    }
  }
`;

export const Content = styled.div`
  margin-top: 16px;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-bottom: 16px;
  white-space: pre-wrap;
`;

export const Footer = styled.div`
  border-top: 1px solid var(--color-accent-secondary-weaker);
  display: flex;
  justify-content: space-between;
  padding-top: 16px;
  width: 100%;
`;

export const OnboardingCard = styled.div`
  display: flex;
  height: 24px;
  position: absolute;
  width: 24px;
  z-index: 4;
`;

export const YellowPointer = styled(Button)`
  position: absolute;
  z-index: 999;
`;
